export const PRIVATE_PERSON_EXPORT_REASON_REFS = {
  ForPersonalUseRef: 'b132cbf5-70d6-11e8-9296-0025b502a04e', // Default reason
  GiftRef: 'eeed5423-8d67-11ee-bd08-d4f5ef0df2b8',
  SaleRef: 'b1336dca-70d6-11e8-9296-0025b502a04e',
  ReturnRef: 'b1333f35-70d6-11e8-9296-0025b502a04e',
  RepairRef: 'b1339e7a-70d6-11e8-9296-0025b502a04e',
};

export const ORGANIZATION_EXPORT_REASON_REFS = {
  SaleRef: 'b1336dca-70d6-11e8-9296-0025b502a04e', // Default reason
  ReturnRef: 'b1333f35-70d6-11e8-9296-0025b502a04e',
  RepairRef: 'b1339e7a-70d6-11e8-9296-0025b502a04e',
  GiftRef: 'eeed5423-8d67-11ee-bd08-d4f5ef0df2b8',
  InternalFacilitiesRef: 'ade13043-c5a5-11ee-bd0a-005056bd05d0',
  SamplesRef: 'ba31fcf3-c5a5-11ee-bd0a-005056bd05d0',
};

export enum EXPORT_TARGET {
  CONTRACT = 'Контракт',
  OTHER = 'Інше',
}

export enum EExportTargetControlNames {
  base = 'ExportTarget',
  target = 'target',
  additionalInfo = 'additionalInfo',
}
